// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_co-2";
export var aiChatCartContainerExit = "_co-4";
export var aiChatContainerLarge = "_co-0";
export var aiChatContainerSmall = "_co-1";
export var aiChatIcon = "_co-6";
export var slideInFromRight = "_co-3";
export var slideOutToRight = "_co-5";